import { render, staticRenderFns } from "./CasePeople.vue?vue&type=template&id=bfd0d008"
import script from "./CasePeople.vue?vue&type=script&lang=js"
export * from "./CasePeople.vue?vue&type=script&lang=js"
import style0 from "./CasePeople.vue?vue&type=style&index=0&id=bfd0d008&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports